import styled, { css, keyframes } from 'styled-components'
import { TypeFiesta } from '@at/design-system-foundation'
import { Button } from '@at/design-system-elements'

export const StyledExpandableFilter = styled.div<{ disabled: boolean }>`
    ${({ theme, disabled }) => css`
        border-top: 1px solid ${theme.color.border.default};
        &:first-child {
            border-top: 0 none;
        }
        &:last-child {
            border-bottom: 1px solid ${theme.color.border.default};
        }
        cursor: ${disabled ? 'not-allowed' : 'default'};
    `}
`

export const FilterTitle = styled(TypeFiesta)`
    font-variation-settings: 'wght' 500;
    color: ${({ theme }) => theme.color.text.title};
    text-align: left;
`

const inAnimation = keyframes`
    0% {
        max-height: 0vh;
    }
    100% {
        max-height: 200vh;
    }
`

const outAnimation = keyframes`
    0% {
        max-height: 200vh;
    }
    100% {
        max-height: 0vh;
    }
`

export const StyledExpandableContent = styled.div<{ isFilterOpen?: boolean }>`
    ${({ isFilterOpen }) => css`
        overflow: hidden;
        animation-name: ${isFilterOpen ? inAnimation : outAnimation};
        animation-duration: 350ms;
        transition: none;
    `}
`

export const StyledClearAllContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
`

export const StyledClearFacetGroupButton = styled(Button)`
    padding-right: 0;
    padding-top: 0;

    &&:hover,
    &&:disabled {
        background-color: transparent;
    }
`
